import { Breadcrumb, Button, Card, Col, DatePicker, Form, Row, Tag, Tooltip } from 'antd'
import CashflowModal from '../../../components/Corporate/Cashflow/CashflowModal'
import style from '../../../components/Sales/style.css'
import CustomSpin from '../../../elements/CustomSpin'
import useFetchSelectUrl from '../../../elements/Hooks/useFetchSelectUrl'
import InfoText from '../../../elements/InfoText'
import PageTitle from '../../../elements/PageTitle'
import CustomTable from '../../../elements/Table/CustomTable'
import numeral from 'numeral'
import React, { Fragment } from 'react'
import { threeFormItemLayout } from '../../../modules/FormItems'
import _ from 'lodash'

const CashTag = (props) => {
  const { value, acc, color, title, setModalData, onShow } = props

  let data = _.get(value, `${acc}.total`)
  data = data ? numeral(data).format('0,0.00') : null
  return data ? (
    <Tooltip title={title}>
      <Tag
        style={{ marginBottom: '8px' }}
        color={color}
        onClick={() => {
          setModalData({ acc, title, ...value })
          onShow()
        }}>
        {data}
      </Tag>
    </Tooltip>
  ) : (
    <div />
  )
}

function Cashflow(props) {
  const {
    range,
    data,
    startDate,
    onChangeDate,
    fetching,
    fetchURL,
    onChangeDay,
    setModalData,
    onShow,
    company,
    setCompany,
  } = props

  console.log({ company })

  const [CompaniesSelect] = useFetchSelectUrl({
    name: `corporates`,
    url: `corporates/`,
    payload: [
      {
        _id:
          'members/294426198169,' + // MONDIALE ENGINEERING SDN BHD
          'members/294426329241,' + // MONDIALE ENGINEERING SDN BHD
          'members/294457000089,' + // MONDIALE GROUP PTE LTD
          'members/10333923050595,' + // MONDIALE GROUP SERVICES KENYA LIMITED
          'members/3473770102937,' + // MONDIALE ME & A DMCC
          'members/294426591385,' + // MONDIALE NIUGINI PTE LTD
          'members/4834795471001,' + // MONDIALE NIUGINI PTE LTD (PNG BRANCH)
          'members/294426722457,' + // MONDIALE STEEL PRODUCTS (CHENGDU) LTD
          'members/294426853529,' + // MONDIALE TECHNICAL SERVICES PTE LTD
          'members/294426984601,' + // MONDIALE TRADING FZE
          'members/294427246745,' + // MONDIALE USA INC
          'members/294428950681', // MUNDO GROUP SERVICES MOCAMBIQUE SA
        fn: '-- ALL MONDIALE GROUP COMPANIES --',
      },
      {
        _id:
          'members/294426460313,' + // MMEA PTE LTD
          'members/294427115673,' + // MMEA (UK) LTD
          'members/10333996845050', // SOUTER TRADING INTERNATIONAL LTD
        fn: '-- ALL MMEA/SOUTER GROUP COMPANIES --',
      },
    ],
  })

  let columns = [
    {
      Header: 'Currency',
      accessor: 'currency',
    },
    ...range.map((r) => ({
      Header: r.format('DD MMMM'),
      accessor: r.format('MMMMDD'),
      Cell: ({ value }) => {
        return (
          <span style={{ display: 'flex', flexDirection: 'column' }}>
            <CashTag
              value={value}
              acc={'payplan.Expected'}
              color={'#f50'}
              title={'Expected'}
              setModalData={setModalData}
              onShow={onShow}
            />
            <CashTag
              value={value}
              acc={'payplan.Scheduled'}
              color={'#2db7f5'}
              title={'Scheduled'}
              setModalData={setModalData}
              onShow={onShow}
            />
            <CashTag
              value={value}
              acc={'payplan.Overdue'}
              color={'#87d068'}
              title={'Overdue'}
              setModalData={setModalData}
              onShow={onShow}
            />
            <CashTag
              value={value}
              acc={'payplan.Invoiced'}
              color={'#108ee9'}
              title={'Invoiced'}
              setModalData={setModalData}
              onShow={onShow}
            />
          </span>
        )
      },
    })),
  ]
  return (
    <CustomSpin spinning={fetching}>
      <Card>
        <Breadcrumb>
          <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
          <Breadcrumb.Item>Corporates</Breadcrumb.Item>
          <Breadcrumb.Item>Cashflow</Breadcrumb.Item>
          <Breadcrumb.Item>
            {startDate.format('MMMM DD')} - {startDate.clone().add(7, 'd').format('MMMM DD')}
          </Breadcrumb.Item>
        </Breadcrumb>

        <PageTitle
          title={'Cashflow'}
          subtitle={`Cashflow From ${startDate.format('MMMM DD')} To ${startDate
            .clone()
            .add(7, 'd')
            .format('MMMM DD')}`}
          color={'#427035'}
          iconType={'dollar'}
        />
      </Card>

      <CashflowModal {...props} />
      <Card className={style.contentCard}>
        <Row>
          <Col span={8}>
            <Row>
              <Button onClick={() => onChangeDay(-1)} style={{ width: 150 }} type="primary" icon="left">
                Previous Day
              </Button>
            </Row>
            <Row>
              <Button onClick={() => onChangeDay(-7)} style={{ width: 150, marginTop: 5 }} icon="left">
                Previous 7 Day
              </Button>
            </Row>
          </Col>
          <Col span={8}>
            <Col>
              <Form.Item {...threeFormItemLayout} label="Start date">
                <DatePicker onChange={onChangeDate} style={{ width: '100%' }} defaultValue={startDate} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item {...threeFormItemLayout} style={{ marginTop: -20 }} label="Company">
                <CompaniesSelect
                  value={company}
                  keyAtr={'_id'}
                  valueAtr={'fn'}
                  style={{ width: '100%' }}
                  onChange={(e) => setCompany(e)}
                />
              </Form.Item>
            </Col>
          </Col>
          <Col span={8}>
            <Row>
              <Button style={{ width: 150, float: 'right' }} onClick={() => onChangeDay(1)} type="primary" icon="right">
                Next Day
              </Button>
            </Row>
            <Row>
              <Button style={{ width: 150, float: 'right', marginTop: 5 }} onClick={() => onChangeDay(7)} icon="right">
                Next 7 Day
              </Button>
            </Row>
          </Col>
        </Row>

        <CustomTable columns={columns} data={data} fetch={fetchURL} showPagination={false} />

        <InfoText
          style={{ marginTop: '25px' }}
          text={
            <Fragment>
              <span style={{ marginRight: '10px' }}>Cashflow Keys :</span>
              <Tag color={'#f50'}>Expected</Tag>
              <Tag color={'#2db7f5'}>Scheduled</Tag>
              <Tag color={'#87d068'}>Overdue</Tag>
              <Tag color={'#108ee9'}>Invoiced</Tag>
            </Fragment>
          }
        />
      </Card>
    </CustomSpin>
  )
}

export default Cashflow
